/**
 * RBAC area/action contract shared between backend enforcement and frontend affordances.
 *
 * Levels are hierarchical: a granted level implies all lower levels.
 *   none < view < edit < delete
 *
 * Effective permission across a principal's roles is the MOST permissive (max level wins),
 * evaluated per area. Backend MUST enforce on every endpoint regardless of UI state.
 */
export const RBAC_AREAS = [
    'agreements',
    'projects',
    'time',
    'customers',
    'products',
    'invoices',
    // `tickets` is the umbrella area (any ticket access), derived as the most-permissive of the
    // two per-origin areas below. `supportTickets` / `projectTickets` gate write/delete by the
    // ticket's origin so a member can, e.g., edit project tickets but not support tickets.
    'tickets',
    'supportTickets',
    'projectTickets',
    'sales',
    'reports',
];
export const RBAC_LEVELS = ['none', 'view', 'edit', 'delete'];
/** Numeric rank used for "most permissive wins" comparisons. Higher = more access. */
export const RBAC_LEVEL_RANK = {
    none: 0,
    view: 1,
    edit: 2,
    delete: 3,
};
export const RBAC_ACTION_MIN_LEVEL = {
    read: 'view',
    write: 'edit',
    delete: 'delete',
};
/** Returns true if `granted` satisfies the `required` hierarchical level. */
export function levelSatisfies(granted, required) {
    return RBAC_LEVEL_RANK[granted] >= RBAC_LEVEL_RANK[required];
}
/** Returns the more permissive of two levels. */
export function maxLevel(a, b) {
    return RBAC_LEVEL_RANK[a] >= RBAC_LEVEL_RANK[b] ? a : b;
}
/** Admin-only operations that are never delegated through area permissions in v1. */
export const ADMIN_ONLY_CAPABILITIES = [
    'manage_roles',
    'manage_members',
    'manage_api_users',
    'manage_connector',
    'manage_qbo_config',
];
/** Seeded default system roles (editable, but cannot be deleted). */
export const DEFAULT_SYSTEM_ROLES = [
    'Admin',
    'Billing Admin',
    'Project Manager',
    'Technician',
];
//# sourceMappingURL=rbac.js.map